import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { PageKitBuilderViewComponent } from './builders/kit-builder/page-kit-builder-view.component';
import { PageOutfitBuilderViewComponent } from './builders/outfit-builder/page-outfit-builder-view.component';
import { CmsBlogPageCategoryViewComponent } from './component/blog/page/category-view/cms-blog-page-category-view.component';
import { CmsBlogPagePostViewComponent } from './component/blog/page/post-view/cms-blog-page-post-view.component';
import { CmsBlogPageRootViewComponent } from './component/blog/page/root-view/cms-blog-page-root-view.component';
import { LocalPage } from './component/page.decorator';
import { PageViewAbstract } from './page-view.abstract';

@Component({
    selector: 'page-view',
    templateUrl: 'page-view.html',
    standalone: true,
    imports: [
        CmsBlogPageCategoryViewComponent,
        CmsBlogPagePostViewComponent,
        CmsBlogPageRootViewComponent,
        ICmsClientModule,
        PageKitBuilderViewComponent,
        PageOutfitBuilderViewComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageViewComponent extends PageViewAbstract {
    @Input()
    override model?: LocalPage<IPageDataV3>;
}
